// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WOQXC","colBig":"styles_colBig__1RWuI","colSmall":"styles_colSmall__230uG"};